<template>
    <Card>
        <div class="table-responsive">
            <table class="table table-hover table-vertical-center">
                <thead>
                <tr>
                    <th>{{ __('general.store') }}</th>
                    <th>FTP-Server</th>
                    <th>Letzter Upload</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="feedUpload in lastFeedUploads">
                    <td>
                        {{ feedUpload.store }}
                    </td>
                    <td>
                        {{ feedUpload.host }}
                        <div class="font-size-sm text-muted">
                            {{ feedUpload.ftp_dir }}
                        </div>
                    </td>
                    <td>{{ timestampToDiffString(feedUpload.source_updated_at) }}</td>
                    <td class="text-right">
                        <a class="btn btn-sm btn-light-warning"
                           :href="$route('admin.messages.write', {type:'feed-outdated', timestamp: feedUpload.source_updated_at,recipient:feedUpload.store_uuid})"
                        >
                            <i class="fas fa-exclamation-circle"/>
                            Warnen
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";

export default {
    components: {Card},

    props: {
        lastFeedUploads: Array
    },

    methods: {
        timestampToDiffString(timestamp) {
            let lastImportDate = new Date(timestamp * 1000);
            let millisecondsSinceLastImport = new Date() - lastImportDate;

            return `vor ${Math.floor(((millisecondsSinceLastImport / 1000) % 31536000) / 86400)} Tagen`
        }
    }
}
</script>
